import type { PracticeForm } from "@physiofit-digital/physiofit_types";

type FormVersion = Partial<Pick<PracticeForm, "formId" | "updatedAt">>;

/** A form restored by a reload stays unless the practice edited it since; an edited form installs fresh. */
export const restoredFormIsCurrent = (restored: FormVersion | undefined, snapshot: FormVersion) =>
  !!restored?.formId && restored.formId === snapshot.formId && restored.updatedAt === snapshot.updatedAt;
